export default __webpack_public_path__ + "static/media/photo9.9d46922d.jpg";